import { Address } from 'models';

const toFileName = (description: string) => {
    // Replace any non-word char (\W) with '_' and remove consecutive underscores
    return description.replace(/\W/g, '_').replace(/_+/g, '_');
};

export const downloadQRCode = (address: Address) => {
    const inMemoryCanvas = document.createElement('canvas');
    inMemoryCanvas.height = 500;
    inMemoryCanvas.width = 500;

    const qrImage = document.getElementById(`qrCode${address.id}`) as HTMLImageElement;
    const link = document.createElement('a');

    if (!qrImage) return;

    const ctx = inMemoryCanvas.getContext('2d');
    const x = inMemoryCanvas.width / 2;

    if (ctx) {
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, inMemoryCanvas.width, inMemoryCanvas.height);
        ctx.fillStyle = 'black';
        ctx.font = '16px serif';
        ctx.textAlign = 'center';
        ctx.fillText(address.description || '', x, 20);
        ctx.font = '12px serif';
        ctx.fillText(`${address.street} ${address.state} ${address.zip_code}`, x, 36);
        ctx.drawImage(qrImage, 50, 50, qrImage.width, qrImage.height);
    }

    link.href = inMemoryCanvas.toDataURL();
    link.download = `${toFileName(address.description || '')}_QRCode.png`;
    link.click();
};
